export default [
  {
    name: 'сот.',
    key: 'sotka',
  },
  {
    name: 'га',
    key: 'hectare',
  },
];
